module.exports = __webpack_public_path__ + "static/media/sethiya ji_page-0001.4179553a.jpg";